import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  effect,
  inject,
  input,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogRef } from '@angular/material/dialog';

export const DIALOG_SHELL_FLUSH_PANEL = 'dialog-shell-flush';

@Component({
  selector: 'xemex-dialog-shell',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './dialog-shell.component.html',
  styleUrl: './dialog-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogShellComponent {
  title = input.required<string>();
  subtitle = input<string>();
  /** Sets the footer on a grey background, for a dialog whose footer carries a summary line
   *  beside its actions. Off by default. */
  mutedFooter = input(false, { transform: booleanAttribute });
  private dialogRef = inject(MatDialogRef, { optional: true });

  constructor() {
    // The muted footer has to reach the surface's rounded edge, which the global dialog style
    // otherwise keeps a transparent border away from.
    effect(() => {
      if (this.mutedFooter()) this.dialogRef?.addPanelClass(DIALOG_SHELL_FLUSH_PANEL);
    });
  }

  close() {
    this.dialogRef?.close();
  }
}
